export default {
  "bare-no-loader": () => import("/usr/src/app/layouts/bare-no-loader.vue").then(m => m.default || m),
  bare: () => import("/usr/src/app/layouts/bare.vue").then(m => m.default || m),
  chiche: () => import("/usr/src/app/layouts/chiche.vue").then(m => m.default || m),
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m),
  error: () => import("/usr/src/app/layouts/error.vue").then(m => m.default || m),
  game: () => import("/usr/src/app/layouts/game.vue").then(m => m.default || m),
  organize: () => import("/usr/src/app/layouts/organize.vue").then(m => m.default || m)
}